"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLegacyAssetType = void 0;
var types_1 = require("@rarible/types");
var big_number_1 = require("@rarible/types/build/big-number");
function toLegacyAssetType(assetType) {
    switch (assetType.assetClass) {
        case "ETH":
            return {
                assetType: 0,
                token: types_1.ZERO_ADDRESS,
                tokenId: big_number_1.toBigNumber("0")
            };
        case "ERC20":
            return {
                assetType: 1,
                token: assetType.contract,
                tokenId: big_number_1.toBigNumber("0")
            };
        case "ERC721":
            return {
                assetType: 3,
                token: assetType.contract,
                tokenId: assetType.tokenId
            };
        case "ERC1155":
            return {
                assetType: 2,
                token: assetType.contract,
                tokenId: assetType.tokenId
            };
    }
    throw new Error("Unsupported ");
}
exports.toLegacyAssetType = toLegacyAssetType;
